import { connect } from "react-redux";
import React, { useContext } from "react";
import Documents from "./Documents";
import {
  getSPDocumentsRequest,
  getHRMDocumentRequest,
  addSPDocumentsLocally,
  updateSPDocumentsRequest,
  deleteSPDocumentsLocally,
} from "../../../../store/actions/sp.actions";
import {
  createFolderRequest,
  updateFolderRequest,
  removeFolderRequest,
  removeFileRequest,
  moveDocumentRequest,
  getFolderListForHRMRequest,
  handleDynamicBreadCrumbForHRMRequest,
} from "../../../../store/actions/cos.actions";
import {
  getDocuments,
  getLoading,
  getHrmDocuments,
  spDocUpdateLoader,
} from "../../../../store/selector/sp.selector";
import {
  createNewFolderLoadingSelector,
  createNewFolderSuccessSelector,
  getRemoveFolder,
  getFolderListForHRMLoadingSelector,
  getFolderListForHRMSelector,
  getFileListForHRMSelector,
  DynamicBreadCrumbSelector,
} from "../../../../store/selector/cos.selector";
import { LoginContext } from "../../../../helpers/LoginContext";
import { getParticipantCall } from "store/actions/participant.actions";

const DocumentsContainer = (props) => {
  const { isUserGracePeriodOver } = useContext(LoginContext);
  
  return <Documents {...props} isUserGracePeriodOver={isUserGracePeriodOver} />;
};

const mapDispatchToProps = {
  getDocument: getSPDocumentsRequest,
  getHrmDocument: getHRMDocumentRequest,
  addSPDocumentsLocally,
  updateSPDocumentsRequest,
  deleteSPDocumentsLocally,
  createFolderRequest,
  updateFolderRequest,
  removeFolderRequest,
  removeFileRequest,
  moveDocumentRequest,
  getFolderListForHRMRequest,
  handleDynamicBreadCrumbForHRMRequest,
  refreshParticipant: getParticipantCall,
};

const mapStateToProps = (state) => {
  const spDocuments = getDocuments(state);
  const hrmDocuments = getHrmDocuments(state);
  const loading = getLoading(state);
  const docUpdateLoader = spDocUpdateLoader(state);
  const createNewFolderLoading = createNewFolderLoadingSelector(state);
  const createNewFolderSuccess = createNewFolderSuccessSelector(state);
  const removeFolderSuccess = getRemoveFolder(state);
  const FolderListForHRM = getFolderListForHRMSelector(state);
  const FileListForHRM = getFileListForHRMSelector(state);
  const getFolderListForHRMLoading = getFolderListForHRMLoadingSelector(state);
  const DynamicBreadCrumb = DynamicBreadCrumbSelector(state);
  return { 
    loading, 
    spDocuments, 
    hrmDocuments, 
    docUpdateLoader,
    createNewFolderLoading,
    createNewFolderSuccess,
    removeFolderSuccess,
    FolderListForHRM,
    FileListForHRM,
    getFolderListForHRMLoading,
    DynamicBreadCrumb,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsContainer);
